import ynToBool from "Utils/ynToBool";

export const HasConciergeService = ynToBool(process.env.REACT_APP_HAS_CONCIERGE);
export const shouldConvertToPoints = ynToBool(process.env.REACT_APP_CONCIERGE_SHOULD_CONVERT_TO_POINTS);

export const ConciergeBanners = {
  SolicitationsListPage: {
    Default: "https://vertice-ds.s3.amazonaws.com/Assets/Images/Concierge/banner.png",
  }
};

export const SolicitationsStatusFilterOptions = [
  {
    value: null,
    label: "Todos os status",
  },
  {
    value: 1,
    label: "Aprovado"
  },
  {
    value: 2,
    label: "Em aprovação"
  },
  {
    value: 4,
    label: "Cancelado"
  }
];